import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="relative min-h-screen">
            {/* Static Diagonal Gradient Background */}
            <div
                className="fixed inset-0 z-0"
                style={{
                    background: 'linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(236, 72, 153) 100%)'
                }}
            />

            {/* Navbar */}
            <nav className="fixed top-0 w-full z-50">
                <div className="relative w-full h-20 py-4">
                    <div
                        className="fixed flex items-center space-x-3"
                        style={{ left: '10%', top: '1.5rem' }}
                    >
                        <button 
                            onClick={() => navigate('/')}
                            className="flex items-center gap-3 text-white hover:opacity-80 transition-opacity duration-200"
                        >
                            <img src="/logo.png" alt="mifamli logo" className="h-12 w-12" />
                            <span className="text-3xl font-bold drop-shadow-lg">mifamli</span>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="relative z-10 min-h-screen flex items-center justify-center px-4 pt-32 pb-16">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-8 text-center">
                        Terms of Service
                    </h1>
                    <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/30 text-left">
                        <p className="text-white/90 leading-relaxed mb-6">
                            <strong>Last updated:</strong> [Placeholder – update with date]
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            By using mifamli ("the Service"), you agree to these Terms of Service. If you do not agree, please do not use the Service.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>Use of the Service:</strong> You agree to use mifamli only for lawful purposes and in accordance with these terms. You are responsible for all content you and your family members add to the platform.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>Account:</strong> You must provide accurate information when creating an account. You are responsible for maintaining the security of your account and for all activity under it.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>Intellectual Property:</strong> mifamli and its content (excluding user-generated content) are owned by us. You retain ownership of content you create.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-6">
                            <strong>Contact:</strong> For questions about these terms, contact us at [placeholder@mifamli.com].
                        </p>
                        <p className="text-sm text-white/70 italic">
                            This is placeholder content. Please review and update before public launch.
                        </p>
                        <button
                            onClick={() => navigate('/')}
                            className="mt-8 px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 rounded-xl text-white font-semibold text-lg hover:bg-white/30 transition-all duration-200"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;

